module.exports = __webpack_public_path__ + "img/avatar_bot_female.8860286e.png";